// Libraries
import { Box, Link } from "@material-ui/core";
import { useObserver } from "mobx-react-lite";
import React from "react";

// Custom
import { PlygeneProductsStyle } from "./PlygeneProductsStyle";

import { isNullOrUndefined } from "Custom/Utils/Utils";

import { PlygeneMoulded } from "./PlygeneSubViews/PlygeneMoulded";
import { PlygeneStandard } from "./PlygeneSubViews/PlygeneStandard";

import { BQSRadioButton } from "./../../../Primitives/RadioButtons/BQSRadioButton";
import { BQSRadioButtons } from "./../../../Primitives/RadioButtons/BQSRadioButtons";

import { PlygeneProductsViewModel } from "Custom/ViewModels/ProductSelector/SubViewModels/GutterSystemSubViewModels/PlygeneProductsViewModel";
import { ProductsCommonViewModel } from "Custom/ViewModels/ProductSelector/SubViewModels/GutterSystemSubViewModels/ProductsCommonViewModel";

interface IProps {
    className?: string;
    commonViewModel: ProductsCommonViewModel;
    viewModel: PlygeneProductsViewModel;
}

export const PlygeneProducts: React.FC<IProps> = (props: IProps) => {
    // #region Code Behind

    const plygeneProductsStyle = PlygeneProductsStyle();

    // #endregion Code Behind

    // #region Render Result

    return useObserver(() => (
        <Box className={plygeneProductsStyle.root}>
            <Box className={plygeneProductsStyle.specificationLink}>
                <Link href="https://www.hdsharman.co.uk/wp-content/uploads/2023/05/Plygene-Specification-Dec-2022-Rev.pdf" target="_blank">
                    View system specification
                </Link>
            </Box>
            <Box>
                <BQSRadioButtons
                    displayName="Which system components are required?"
                    execute={props.viewModel.setProductSelection}
                    row={false}
                    value={!isNullOrUndefined(props.viewModel.productSelection) ? props.viewModel.productSelection.value : undefined}
                >
                    {props.viewModel.products.map((item) => (
                        <BQSRadioButton displayName={item.title} key={item.value} value={item.value} />
                    ))}
                </BQSRadioButtons>
                {props.viewModel.canDisplayMoulded && <PlygeneMoulded commonViewModel={props.commonViewModel} viewModel={props.viewModel.PlygeneMouldedViewModel} />}
                {props.viewModel.canDisplayStandard && <PlygeneStandard commonViewModel={props.commonViewModel} viewModel={props.viewModel.PlygeneStandardViewModel} />}
            </Box>
        </Box>
    ));

    // #endregion Render Result
};
